import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import { goToNextPageAsync } from '../../ServiceAppointmentAsyncthunk';
import { goToPage } from '../../ServiceAppointmentBlockSlice';
import { navigateTo } from '../../../../../utilities/StringHelpers/StringHelpers';
import wifi from '../../images/wifi.svg';
import PowerSupplyIcon from '../../images/power_supply.svg';
import ExclamationMark from '../../images/exclamationMark.svg';
import YellowExclamationMark from '../../images/yellow_exclamation_mark.svg';
import Config from '../../../../../Config';


const ServiceRequestMainPage = (props) => {
    const [selectedRadio, setSelectedRadio] = useState(null);
    const [error,setError] = useState(null);

    let title = null;
    let subTitle = null;
    let isDisplayLink = false;
    let btnText = 'המשך';
    let dataRadioInput = [];
    let dataLinks = [];
    let isMessage = false;
    let image = null;
    let imgEpi = null;

    function handleOnContinue(item) {
        if(selectedRadio !== null){
            props.goToNextPageAsync(item);
            setSelectedRadio(null)
        }else {
            setError('יש לבחור אחת מהאפשרויות כדי להמשיך')
        };
    };

    function handleOnLinks(item, indexLink) {
        if (indexLink === 0) {
            navigateTo(props.buttonUserPassword);
        } else if (indexLink === 1) {
            props.goToPage({page: 'routerConnectionPage', typePage: ''});
        };
    };

    function handleRadioChange(event) {
        setSelectedRadio(event.target.value);
        setError(null);
    };

    switch (props.typePage) {
        case 'YOUR_INTERNET_STATUS_1_1':
            title = <> מה מצב האינטרנט שלך כרגע?</>;
            dataRadioInput = [
                { id: 'no_internet', label: 'אין חיבור לאינטרנט' },
                { id: 'internet_connection_is_slow', label: 'הגלישה באינטרנט איטית' },
                { id: 'disconnections_in_the_connection', label: 'יש ניתוקים בגלישה' }
            ];
            isDisplayLink = true;
            dataLinks = ['מה שם המשתמש והסיסמה לספק שלי?', `איך מתחברים לנתב של ${window.Config.brand_Name_HE}?`];
            break;
        case 'NO_INTERNET_CONNECTION_1_1_1':
            title = <> האם בכל המכשירים בבית אין חיבור אינטרנט?</>;
            dataRadioInput = [
                { id: 'appliances_in_the_house_are_not_working', label: 'לא ניתן לגלוש בכל המכשירים' },
                { id: 'some_devices_have_an_internet_connection', label: 'חלק מהמכשירים מצליחים לגלוש' }
            ];
            btnText = 'המשך';
            break;
        case 'INTERNET_CONNECTION_TYPE_1_1_2':
            title = <> איך המכשיר מחובר לאינטרנט?</>;
            dataRadioInput = [
                { id: 'wifi_connection', label: 'Wi -Fi' },
                { id: 'wired_connection', label: 'חיבור קווי' }
            ];
            btnText = 'המשך';
            break;
        case 'INTERNET_CONNECTION_TYPE_1_1_1_2':
            title = <> איך המכשיר מחובר לאינטרנט?</>;
            dataRadioInput = [
                { id: 'wifi_connection', label: 'Wi -Fi' },
                { id: 'wired_connection', label: 'חיבור קווי' }
            ];
            btnText = 'המשך';
            break;
        case 'INTERNET_CONNECTION_TYPE_1_1_3':
            title = <>איך המכשיר מחובר לאינטרנט?</>;
            dataRadioInput = [
                { id: 'wifi_connection', label: 'Wi -Fi' },
                { id: 'wired_connection', label: 'חיבור קווי' }
            ];
            btnText = 'המשך';
            break;
        case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_2':
            imgEpi = props.routerDisplay[0]?.goodBulbsImage?.src;
            title = <> האם הנורות נדלקו כמו בתמונה?</>;
            dataRadioInput = [
                { id: 'shown_as_in_the_picture', label: 'הנורות נדלקו כמו בתמונה' },
                { id: 'lights_turned_on_differently', label: 'הנורות נדלקו באופן שונה מהתמונה' },
                { id: 'lights_didnt_turn_on', label: 'הנורות לא נדלקו' }
            ];
            isMessage = true;
            btnText = 'המשך';
            break;
        case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_3':
            imgEpi = props.routerDisplay[0]?.goodBulbsImage?.src;
            title = <> האם הנורות נדלקו כמו בתמונה?</>;
            dataRadioInput = [
                { id: 'shown_as_in_the_picture', label: 'הנורות מוצגות כמו בתמונה' },
                { id: 'lights_turned_on_differently', label: 'הנורות נדלקו באופן שונה מהתמונה' },
                { id: 'lights_didnt_turn_on', label: 'הנורות לא נדלקו' }
            ];
            isMessage = true;
            btnText = 'המשך';
            break;
        case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_4':
            imgEpi = props.routerDisplay[0]?.goodBulbsImage?.src;
            title = <> האם הנורות נדלקו כמו בתמונה?</>;
            dataRadioInput = [
                { id: 'shown_as_in_the_picture', label: 'הנורות מוצגות כמו בתמונה' },
                { id: 'lights_turned_on_differently', label: 'הנורות נדלקו באופן שונה מהתמונה' },
                { id: 'lights_didnt_turn_on', label: 'הנורות לא נדלקו' }
            ];
            isMessage = true;
            btnText = 'המשך';
            break;
        case 'MANUALLY_ACTIVATING_ROUTER':
            image = ExclamationMark;
            title = <>נראה שההפעלה מחדש האוטומטית לא עזרה, יש להפעיל מחדש ידנית</>;
            subTitle = <> יש לכבות את הנתב ולהפעילו מחדש, ולאחר מכן להמתין 90 שניות</>;
            isMessage = true;
            btnText = 'כיביתי והפעלתי מחדש את הנתב';
            break;
        case 'ROUTER_MUST_BE_RESTARTED':
            image = ExclamationMark;
            title = <>יש לבצע הפעלה מחדש</>;
            subTitle = <> יש לכבות את הנתב ולהפעילו מחדש, ולאחר מכן להמתין 90 שניות.</>;
            isMessage = true;
            btnText = 'כיביתי והפעלתי מחדש את הנתב';
            break;
        case 'CONNECTION_FIXED':
            image = ExclamationMark;
            title = <>נסיון תיקון החיבור נכשל</>;
            dataRadioInput = [
                { id: 'you_can_surf_the_internet', label: 'כן, אפשר לגלוש באינטרנט' },
                { id: 'you_still_cant_surf', label: 'לא, עדין אי אפשר לגלוש' }
            ];
            btnText = 'המשך';
            break;
        case 'PERFORMED_TESTS_CONNECTION':
            image = wifi;
            title = <> ביצענו בדיקות ונראה שהחיבור תקין, נסו לגלוש עכשיו</>;
            dataRadioInput = [
                { id: 'you_can_surf_the_internet', label: 'כן,אפשר לגלוש באינטרנט' },
                { id: 'you_still_cant_surf', label: 'לא, עדין אי אפשר לגלוש' }
            ];
            btnText = 'המשך';
            break;
        case 'SELECT_DELIVERY_POWER_SUPPLY':
            image = PowerSupplyIcon;
            title = <> מצאנו שיש בעיה בספק כוח <br/> ויש להחליף אותו</>;
            subTitle = <>איך הכי נוח לך לקבל ספק חדש?</>;
            dataRadioInput = [
                { id: 'pickup', label: 'לאסוף מנקודת חלוקה קרובה',  price: 'ללא עלות' , badge: 'איסוף מיידי' },
                { id: 'delivery', label: 'משלוח עד הבית', subLabel: 'זמן המשלוח לפי זמינות' , price: 'ללא עלות'},
            ];
            btnText = 'המשך';
            break;
    };


    return (
        <div className='page-service-request-main-page page-wrapper'>
             <div className='content'>
                {imgEpi  && <Image src={ imgEpi } alt={'image'} className='image-service' />}
                {image && <Image src={ image } alt={'image'} className='image-service' />}
                {title && <div className='page-title'> {title} </div>}
                {subTitle && <div className='page-sub-title'> {subTitle} </div>}
                <div className='container-radio'>
                    {dataRadioInput.map((item, i) => (
                        <div className={`radio-wrapper ${selectedRadio ===  item.id ? 'checked': ''}`} key={i}>
                            <RadioInput
                                name={`internet-type`}
                                id={`internet-type-${i}`}
                                value={item.id}
                                label={item.label}
                                subLabel={item.subLabel}
                                price={item.price}
                                badge={item.badge}
                                checked={selectedRadio === item.id}
                                onChange={handleRadioChange}
                            />
                        </div>
                    ))}
                </div>
                {isDisplayLink &&
                  <div className='container-links'>
                        {dataLinks.map((item, i) => (
                            <div className='links-wrapper' key={i}>
                                <div className='link'>
                                    <a href='#' onClick={() => handleOnLinks(item, i)}>{item}</a>
                                </div>
                            </div>
                        ))}
                  </div>
                }
                {isMessage && selectedRadio === 'wired_connection' &&
                    <div className='wrapper-message'>
                        <Image src={YellowExclamationMark} alt='icon' />
                        <div className='text'>יש לבצע את הבדיקה במרחק של עד שני מטרים מהנתב</div>
                    </div>
                }
            </div>
            <div className='button-wrapper'>
                {error && <div className='error-service-request'> {error}</div>}
                <BtnSubmit
                    className='btn-submit-purple'
                    isBusiness={false}
                    text={btnText}
                    onclick={() => handleOnContinue(selectedRadio)}
                    formid='error-page'
                    isDisplayArrows={false}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        typePage: state.serviceAppointmentSchedulerBlock.typePage,
        buttonUserPassword: state.serviceAppointmentSchedulerBlock.dataEpi.buttonUserPassword,
        routerDisplay:state.serviceAppointmentSchedulerBlock.routerDisplay
    };
};

const mapDispatchToProps = {
    goToPage,
    goToNextPageAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestMainPage);
